// Injects the required-asterisk into the last <p> of a Quill-produced HTML
// label so it visually attaches to the last line of the rendered text.
//
// Why: Quill wraps each line in <p>. Rendering the asterisk as a sibling
// text node outside the rich-text span lands it on its own line because the
// preceding <p> is block-level. Inlining all <p> elements (a previous CSS
// fix) put the asterisk back on the same line but flattened every paragraph
// onto one row. Injecting the asterisk into the last <p> lets paragraphs
// stay block while keeping the asterisk attached to the final line.
export const appendAsteriskToLastParagraph = (html, required) => {
  if (!required || !html) return html;
  const lastClosingP = html.lastIndexOf("</p>");
  if (lastClosingP === -1) return `${html} *`;
  return `${html.slice(0, lastClosingP)} *${html.slice(lastClosingP)}`;
};